
  // Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        showLimitList: '24,36,48'
    },
};

// Declare Templates
var bcSfFilterTemplate = { 
    // Grid Template
    'productGridItemHtml': '<article class="{{customClass}} {{promo4x2}}" data-product-item tabindex="1" data-limoniapps-discountninja-product-handle="{{itemHandle}}" data-limoniapps-discountninja-product-price="{{itemPriceMin}}" data-limoniapps-discountninja-product-compareatprice="{{itemCompareAtPriceMax}}" data-limoniapps-discountninja-product-collections="{{itemCollections}}">' +
                              '<div id="{{itemHandle}}" class="productitem" data-product-item-content>' +
  //'{{promo2x1}}' +
  '{{label_rest}}' +
                                '<a class="productitem--image-link" href="{{itemUrl}}">' +
  
  '{{customNewLabel}}' + '{{itemBadgeColl}}' +
  '{{customNewLabel_gray}}' +

                                  '<figure class="productitem--image" data-product-item-image>' +
                                  '{{itemImages}}' +
                                  '{{itemLabels}}' +
                                  '</figure>' +
                                '</a>' +
                                '<div class="productitem--info" data-limoniapps-discountninja-product-handle="{{itemHandle}}" data-limoniapps-discountninja-product-price="{{itemPriceMin}}" data-limoniapps-discountninja-product-compareatprice="{{itemCompareAtPriceMax}}" data-limoniapps-discountninja-product-collections="{{itemCollections}}">' +
                                    '{{itemVendor}}' +
                    '<p class="productitem--title" style="margin-bottom: 10px;margin-top:0;">' +
                                    '<a href="{{itemUrl}}" tabindex="1">' +
                                      '{{customNewName}}' +
                                    '</a>' +
                                  '</p>' +
                                    '{{noEmphasizePrice}}'  +
                                    '{{emphasizePrice}}'  +
                                  '{{itemReviews}}' +
                                '</div>' +
                                '{{quickBtn}}' +
                                '{{envio_express}}' +
                              '</div>' +
                            '</article>',

    // List Template
    'productListItemHtml': '<article class="{{customClass}}" data-limoniapps-discountninja-product-handle="{{itemHandle}}" data-limoniapps-discountninja-product-price="{{itemPriceMin}}" data-limoniapps-discountninja-product-compareatprice="{{itemCompareAtPriceMax}}" data-limoniapps-discountninja-product-collections="{{itemCollections}}">' +
    '<div id="{{itemHandle}}" class="productitem">' +
    '<a class="productitem--image-link" href="{{itemUrl}}">' +
    '<div class="boost-pfs-flair-{{itemId}} flair"></div>'+
    '<figure class="productitem--image" data-product-item-image>' +
    '{{itemImages}}' +
    '{{itemLabels}}' +
    '</figure>' +
    '</a>' +
    '<div class="productitem--info" data-limoniapps-discountninja-product-handle="{{itemHandle}}" data-limoniapps-discountninja-product-price="{{itemPriceMin}}" data-limoniapps-discountninja-product-compareatprice="{{itemCompareAtPriceMax}}" data-limoniapps-discountninja-product-collections="{{itemCollections}}">' +
    '{{emphasizePrice}}'  +
    '<h2 class="productitem--title">' +
    '<a href="{{itemUrl}}" tabindex="1">' +
    '{{itemTitle}}' +
    '</a>' +
    '</h2>' +
    '{{noEmphasizePrice}}'  +
    '{{itemVendor}}' +
    '{{itemReviews}}' +
    '{{itemDescription}}' +
    '</div>' +
    '{{quickBtn}}' +
    '</div>' +
    '</article>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination--previous"><a class="pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon> </g> </svg></span>' + bcSfFilterConfig.label.prev + '</a></li>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<li class="pagination--next"><a class="pagination--item" href="{{itemUrl}}">' + bcSfFilterConfig.label.next + '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon> </g> </svg></span></a></li>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li><a class="pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
    'paginateHtml': '<div class="pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',

    // Sorting Template
    'sortingHtml':  '<label class="utils-sortby-title" for="product_grid_sort">' + bcSfFilterConfig.label.sorting + '</label>' +
    '<div class="utils-sortby-select form-field-select-wrapper no-label">' +
    '<select class="form-field form-field-select">{{sortingItems}}</select>' +
    '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon> </g> </svg>' +
    '</div>'+
  
  	'<div class="probadorVirtuall" m-lente="probadorVirtuall">'+
  	'<svg style="fill: #000;" width="25px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve"><path class="st0" d="M37.94,88.69c0,0-5.09-30.58,10.18-57.34s62.43-33.12,89.19-15.31c26.76,17.85,28.03,43.34,26.76,72.65c0,0,10.18,1.27,5.09,25.49c-5.09,24.22-16.58,30.58-16.58,30.58s-11.45,45.89-52.25,45.89s-50.94-47.16-50.94-47.16s-16.58-14.04-17.85-31.85C30.3,93.78,37.94,88.69,37.94,88.69z M157.62,83.44c1.27-30.58-3.74-57.18-36.86-67.36s-62.43,5.09-70.1,24.22S44.3,83.6,44.3,83.6 M44.91,83.44c0,0-24.37,33.51,10.84,58.8c0,0,12.72,42.07,44.61,42.07s47.16-38.21,47.16-43.34c0,0,31.43-24.02,10.1-57.53"></path><g><path class="st0" d="M99.36,83.79c2.7,0,10.72-3.59,24.18-5.36c13.42-1.77,37.6,0,38.48,1.77c0.89,1.77,0.89,7.17,0,8.06c-0.89,0.89-1.77,0-3.59,8.06c-1.81,8.06-3.59,20.59-16.12,22.36s-24.18,0-29.54-8.06c-5.36-8.06-7.17-14.31-8.06-16.12c-0.89-1.77-1.77-4.47-5.36-4.47c0,0-2.7-0.89-4.47,3.59c-1.77,4.47-2.7,11.64-7.17,17c-4.47,5.36-8.95,8.06-21.48,8.95s-17.89-2.7-20.59-10.72c-2.7-8.06-4.47-18.78-6.25-19.7c-1.77-0.93-1.77-8.06-0.89-8.95c0.89-0.89,22.36-2.7,31.31-2.7s22.36,4.47,25.06,5.36C97.59,83.79,99.36,83.79,99.36,83.79z M51.86,107.62c2.31,7.75,20.9,10.84,27.88,3.08c6.98-7.75,7.75-17.81,6.98-20.9c-0.77-3.08-6.98-4.63-13.92-5.44c-6.98-0.77-17.39-0.42-20.9,3.08C49.54,89.81,49.54,99.87,51.86,107.62z M115.25,102.45c3.05,6.09,6.82,10.64,15.96,11.41c9.1,0.77,15.19-0.77,17.47-9.1s0.77-15.96-0.77-17.47c-1.54-1.5-9.87-3.82-19.74-3.05c-9.87,0.77-13.69,3.82-14.42,5.32C113.74,89.54,112.2,96.36,115.25,102.45zM42.99,83.37c-1.23,0-2.24,0.39-2.24,0.89s1,0.89,2.24,0.89c1.23,0,2.24-0.39,2.24-0.89S44.22,83.37,42.99,83.37z M157.55,83.37c-1.23,0-2.24,0.39-2.24,0.89s1,0.89,2.24,0.89s2.24-0.39,2.24-0.89S158.78,83.37,157.55,83.37z"></path></g></svg>'+
    '<p>Probador Virtual</p>'+
    '<div class="switch-wrapper">'+
    '<input type="checkbox" id="switchBox1"class="switch-input probadorVirtualInput">'+
    '<label for="switchBox1" class="switch-label switchProbador"></label>'+
    '</div>'+
    '</div>',
  
    // Show limit Template
    'showLimitHtml': '<li><span class="utils-showby-title">' + bcSfFilterConfig.label.show_per_page + '</span></li>{{showLimitItems}}',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  
  // Add custom class
  var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
  if (onSale) customClass += ' productitem--sale';
  if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
  itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '512x') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add images 
  var itemImagesHtml = '';
  if (images.length > 1 && bcSfFilterConfig.custom.show_second_image) {
    itemImagesHtml += '<noscript data-rimg-noscript>' +
      '<img src="' + this.optimizeImage(images[1].src, '512x512') + '" alt="{{itemTitle}}"' +
      'data-rimg="noscript" class="productitem--image-alternate"' +
      'srcset="' + this.optimizeImage(images[1].src, '512x512') + '"' +
      '>' +
      '</noscript>';
    itemImagesHtml += '<img src="' + this.optimizeImage(images[1].src, '512x512') + '" class="productitem--image-alternate" alt="{{itemTitle}}" ' +
      'data-rimg="loaded" data-rimg-scale="1" data-rimg-template="' + this.optimizeImage(images[1].src, '{size}') + '" ' +
      'data-rimg-max="' + images[1]['width'] + 'x' + images[1]['height'] + '" data-rimg-crop ' +
      'srcset="' + this.optimizeImage(images[1].src, '512x512') + '" ' +
      'data-rimg-template-svg="data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\'512\'%20height=\'512\'></svg>"' +
      '>';
    itemImagesHtml += '<div data-rimg-canvas></div>';
  }
  if (images.length > 0) {
    itemImagesHtml += '<noscript data-rimg-noscript>' +
      '<img src="' + this.optimizeImage(images[0].src, '512x512') + '" alt="{{itemTitle}}"' +
      'data-rimg="noscript"' +
      'srcset="' + this.optimizeImage(images[0].src, '512x512') + '"' +
      '>' +
      '</noscript>';
    itemImagesHtml += '<img src="' + this.optimizeImage(images[0].src, '512x512') + '" alt="{{itemTitle}}" ' +
      'data-rimg="loaded" data-rimg-scale="1" data-rimg-template="' + this.optimizeImage(images[0].src, '{size}') + '" ' +
      'data-rimg-max="' + images[0]['width'] + 'x' + images[0]['height'] + '" data-rimg-crop ' +
      'srcset="' + this.optimizeImage(images[0].src, '512x512') + '" ' +
      'data-rimg-template-svg="data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\'512\'%20height=\'512\'></svg>"' +
      '>';
    itemImagesHtml += '<div data-rimg-canvas></div>';
  }
  itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

  // Add Label
  var itemLabelsHtml = '';
  if (soldOut) {
    itemLabelsHtml += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out +'</span>';
  } else {
    if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
      var savePrice = data.compare_at_price_min - data.price_min;
      var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_max);
      var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
      var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
      itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
      switch (bcSfFilterConfig.custom.product_sales_badge_style) {
        case 'percentile': itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml); break;
        case 'money': itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice)); break;
        default: itemLabelsHtml += bcSfFilterConfig.label.sale; break;
      }
      itemLabelsHtml += '</span>';
    }
  }
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);


  var comparePrice = data.compare_at_price_max || 0;
  itemHtml = itemHtml.replace(/{{itemCompareAtPriceMax}}/g, comparePrice);
  itemHtml = itemHtml.replace(/{{itemPriceMin}}/g, data.price_min);

  var itemCollections = data.collections.map(function(collection){
    return collection.handle;
  });
  itemHtml = itemHtml.replace(/{{itemCollections}}/g, itemCollections.join());

 
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //-----------------------------------------------------ETIQUETAS DE COLECCIONES-----------------------------------------------------------------
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Etiquetas para colecciones
  var itemBadgeColl = '';
  var collection_name_qty = bcSfFilterConfig.custom.collection_name_qty;
  if(collection_name_qty > 0){
    var collection_name = bcSfFilterConfig.custom.collection_name;
    var collection_tag = bcSfFilterConfig.custom.collection_tag;
    var collection_date = bcSfFilterConfig.custom.collection_date;
    var collection_color = bcSfFilterConfig.custom.color_tag;

    var coll_name = collection_name.split('|');
    var tag_label = collection_tag.split('|');
    var tag_date = collection_date.split('|');
    var coll_color = collection_color.split('|');

    for (var i = 0; i < collection_name_qty; i++) {
      var tag_date_split = tag_date[i].split('/');
      //ordenar fecha inicio a formato UTC (YYYY-MM-DD)
      var tag_date_init_full = tag_date_split[0];
      var tag_date_init_full_split = tag_date_init_full.split('-');
      var tag_date_init_string = tag_date_init_full_split[2]+'/'+tag_date_init_full_split[1]+'/'+tag_date_init_full_split[0];
      var tag_date_init = new Date(tag_date_init_string);
      //ordenar fecha culminación a formato UTC (YYYY-MM-DD)
      var tag_date_end_full = tag_date_split[1];
      var tag_date_end_full_split = tag_date_end_full.split('-');
      var tag_date_end_string = tag_date_end_full_split[2]+'/'+tag_date_end_full_split[1]+'/'+tag_date_end_full_split[0];
      var tag_date_end = new Date(tag_date_end_string);
      //ordenar fecha actual a formato UTC (YYYY-MM-DD)
      var js_today = new Date();
      var js_dd = String(js_today.getDate()).padStart(2, '0');
      var js_mm = String(js_today.getMonth() + 1).padStart(2, '0'); //Enero es 0!
      var js_yyyy = js_today.getFullYear();
      js_today = js_yyyy+ '/' +js_mm+ '/'+ js_dd;
      var today_date = new Date(js_today);

      if (tag_date_init <= today_date && today_date <= tag_date_end) {
        var coll_i = data.collections.find(item => item.title === coll_name[i]);
        if(coll_i){itemBadgeColl += '<div style="background-color: '+coll_color[i]+'; padding: 3px 5px; color: #ffffff; position: absolute; top: 17px; text-align: center; left: 0px; z-index: 999; font-size: 0.7rem; border-radius: 2px;">'+tag_label[i]+'</div> '; break;}  
      } 
    }
  }

  itemHtml = itemHtml.replace(/{{itemBadgeColl}}/g, itemBadgeColl);

    var priceHtml = '<span class="span-price-content ">';
    var classVaries = priceVaries ? 'price--varies' : '';
    var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
    priceHtml += '<div class="productitem--price rttt' + classVaries + '">';

    //Aqui empieza el precio de venta
    priceHtml += '<div class="price--main" data-price style="font-size:1.15rem; width: 100%;">';
    var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';

    if (onSale && typeof data.percent_sale_min !== 'undefined' && data.percent_sale_min > 0) {
      price += '<span style="background-color: #ff4438;color: #ffffff;padding: 5px 5px !important;font-size: 0.8rem;margin-left: 10px;position: relative;top: -2.5px;">' +
        data.percent_sale_min + '% OFF</span><br>';
    }

    if (priceVaries) { //ESTE CÓDIGO ES POR SI EL PRECIO TIENE VARIANTES
      priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, price);
    } else {
      priceHtml += price;
    }
    
    priceHtml += '</div>'; //aqui termina el precio de venta


    //Aqui empieza el precio de comparación
    if (onSale == true){
      priceHtml += '<div class="price--compare-at ' + visibleClass + '" data-price-compare-at>';
      var comparePrice = '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>';
      if (priceVaries && onSale){
        priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, comparePrice);
      } else {
        if (onSale) {
          priceHtml += comparePrice;
        } else {
          if (bcSfFilterConfig.custom.emphasize_price) {
            priceHtml += '<span class="price--spacer"></span>';
          } else {
            priceHtml += '<span class="money"></span>';
          }
        }
      }
      priceHtml += '</div></div>'; //Aquí termina el precio de comparación
    
      if(data.product_type == 'Lentes de Contacto'){priceHtml += '<span style="color: #ff4438; font-weight: bold; font-size: 14px; position: relative; top: 5px;">Envío Gratis</span>';}    
      priceHtml += '</span>'; // Termina Add Price
    }else{
      priceHtml += '</div>'; //Aquí termina el precio de comparación
      if(data.product_type == 'Lentes de Contacto'){priceHtml += '<span style="color: #ff4438; font-weight: bold; font-size: 14px; position: relative; top: 5px;">Envío Gratis</span>';}    
      priceHtml += '</span>'; // Termina Add Price
    }
 
  
  
  
  // Add emphasize price
  var emphasizePriceHtml = '';
  var noEmphasizePriceHtml = '';
  if (bcSfFilterConfig.custom.emphasize_price) {
    emphasizePriceHtml += priceHtml;
  } else {
    noEmphasizePriceHtml += priceHtml;
  }
  itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
  itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

  // Add vendor
  var itemVendorHtml = '';
  if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '') {
    itemVendorHtml += '<p class="productitem--vendor" style="margin-top:10px; text-transform: uppercase;">' + data.vendor + '</p>';
  }
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add review rating
  var itemReviewsHtml = '';
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    itemReviewsHtml +=  '<div class="productitem--ratings">' +
      '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
      '<span class="spr-badge">' +
      '<span class="spr-starrating spr-badge-starrating">' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '</span>' +
      '</span>' +
      '</span>' +
      '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

  // Add quickBtn
  var quickBtnHtml = '';
  var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
  var show_modal = bcSfFilterConfig.custom.show_modal;
  if (bcSfFilterConfig.custom.enable_quick_look == true || bcSfFilterConfig.custom.enable_quick_buy == true) {
    var quick_look_text = bcSfFilterConfig.label.quick_look_text;
    var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
    var quick_look_classes = 'productitem--action-trigger button-secondary';
    var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
    if (has_variants) {
      quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
      show_modal = true;
    }
    if (itemCollections.includes("lentes-de-contacto") || itemCollections.includes("lentes-oftalmicos")) { 
      quick_buy_text = 'Ver Lentes';
    }
    if (!data.available) {
      quick_buy_text = bcSfFilterConfig.label.sold_out;
      quick_buy_classes = quick_buy_classes + ' disabled';
    }
    quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
    if (bcSfFilterConfig.custom.enable_quick_look) {
      quickBtnHtml += '<div class="productitem--action">' +
        '<button class="'+ quick_look_classes +'" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' + quick_look_text +
        '</button>' +
        '</div>';
    }
    if (bcSfFilterConfig.custom.enable_quick_buy) {

      if (!has_variants) {
        var temp = ' data-quick-buy ';
      } else {
        var temp = ' data-quickshop-slim ';
      }

      if (itemCollections.includes("lentes-de-contacto") || itemCollections.includes("lentes-oftalmicos")) {
        quickBtnHtml += '<div class="productitem--action" style="transform: translateY(10px);">' +
          '<form action="{{itemUrl}}">' +
          '<button class="' + quick_buy_classes + '" tabindex="1" type="submit" ';
        if (!data.available) {
          quickBtnHtml += ' disabled';
        }
        quickBtnHtml += '>';
        quickBtnHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
        quickBtnHtml += '</button>';
        quickBtnHtml += '</form>';
        quickBtnHtml += '</div>';

      } else {
        quickBtnHtml += '<div class="productitem--action" style="transform: translateY(10px);">' +
          '<button class="' + quick_buy_classes + '" tabindex="1" type="button" aria-label="' + quick_buy_text + '"' +
          temp + 'data-variant-id="' + data.variants[0].id + '"';
        if (!data.available) {
          quickBtnHtml += ' disabled';
        }
        quickBtnHtml += '>';
        quickBtnHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
        quickBtnHtml += '<span class="atc-button--icon">';
        quickBtnHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path> </g> </svg>';
        quickBtnHtml += '</span>';
        quickBtnHtml += '</button>';
        quickBtnHtml += '</div>';
      }
    }

    quickBtnHtml += '</div>';
  }
  itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemType}}/g, data.product_type);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  
  //ENVÍO EXPRESS 
  function buildNewLabel_envio_express(data){
    var showNewBadge = data.collections.find(item => item.title === 'Envío Express');
    var showNewBadge_2 = data.collections.find(item => item.title === 'Envío Express Manual');
    var showNewBadge_3 = data.collections.find(item => item.title === 'Lentes marcas de lujo envío express');
    var html = "";
    if(showNewBadge || showNewBadge_2 || showNewBadge_3){
        //html += '<div class="pos-envioexpress"><p style="margin:0;">ENVÍO EN 24 HORAS</p></div>';
    }
    return html;
  }
  itemHtml = itemHtml.replace(/{{envio_express}}/g, buildNewLabel_envio_express(data));

  //VTO (VTO Ultima opción si es que hay algun otro tag con promoción)
  function buildNewLabel_dynamic(data){
    var showNewBadge_vto = data.collections.find(item => item.title === 'Probador virtual');
     var html = "";
    if(showNewBadge_vto){
      html += '<div class="vto-label">';
      html += '<img src="https://cdn.shopify.com/s/files/1/0050/9893/0225/files/Icono_Probador_Virtual_new_Oftalmicos.png?v=1673377874" style="max-width: 125px; height: auto;">';
      html += '</div>';
    }
    return html;
  }
  itemHtml = itemHtml.replace(/{{customNewLabel}}/g, buildNewLabel_dynamic(data));

  //Niño o Cupon 120
  function buildNewLabel_gray(data){
    var showNewBadge = data.collections.find(item => item.title === 'Lentes de Sol FLAG');
    var showNewBadge2 = data.collections.find(item => item.title === 'Lentes Oftálmicos FLAG');
    var showNewBadge_nino = data.collections.find(item => item.title === 'Lentes Oftalmicos - Niños');
    var showNewBadge_ninosol = data.collections.find(item => item.title === 'Lentes de Sol para Niños');
    
    var html = "";
    var price_cupon_flag = data.price_min;
    if(showNewBadge_nino || showNewBadge_ninosol){
      html += '<div class="rx-label">';
      html += '<p>NIÑOS</p>';
      html += '</div>';
    }else{
      if(price_cupon_flag > 44900){
        if(showNewBadge || showNewBadge2){
          html += '<div class="rx-label">';
            html += '<p>Cupón S/120</p>';
            html += '</div>';
        }
      }
    }
    
    return html;
  }
  itemHtml = itemHtml.replace(/{{customNewLabel_gray}}/g, buildNewLabel_gray(data));
  
  
  function buildNewLabel_productName(data){
    var showNewName_2 = data.product_type;
    var html = "";
    if(showNewName_2 == 'Lentes de Contacto'){
        html += data.title;
    }else{
      html += data.product_type;
    }
    return html;
  }
  
  itemHtml = itemHtml.replace(/{{customNewName}}/g, buildNewLabel_productName(data));

  // Promoción 4x2
  function buildNewLabel_promo4x2(data){
      var showNewBadge = data.collections.find(item => item.title === '4x2LC');
      var html = "";
      if(showNewBadge){
          html += 'promo-4x2-label';
      }
      return html;
  }
  itemHtml = itemHtml.replace(/{{promo4x2}}/g, buildNewLabel_promo4x2(data));

  // Promoción 2x1
  function buildNewLabel_promo2x1(data){
      var showNewBadge = data.collections.find(item => item.title === 'Solares EB 2x1'); 
      var html = "";
      if(showNewBadge){
        html += '<div style="background-color: #f94337; padding: 3px 15px; color: #ffffff; position: absolute; top: 25px; left: 10px; z-index: 999;">2 x 1</div>';
      }
      return html;
  }
  itemHtml = itemHtml.replace(/{{promo2x1}}/g, buildNewLabel_promo2x1(data));

  //Lentes de descanso
  function buildNewLabel_rest(data){
    var showNewBadge = data.collections.find(item => item.title === 'Lentes de Descanso');
    var html = ""; 
    if(showNewBadge){
      // html += '<div class="rest-label">';
      //   html += '<img src="https://cdn.shopify.com/s/files/1/0050/9893/0225/files/VC-03-03.png?v=1637583163" style="max-width:100%;">';
      //   html += '</div>';
    }
    return html;
  }
  itemHtml = itemHtml.replace(/{{label_rest}}/g, buildNewLabel_rest(data));



  
  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data, index, totalProduct) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;

  // Add custom class
  var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
  if (onSale) customClass += ' productitem--sale';
  if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
  itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '512x') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  var itemImagesHtml = '';
  if (images.length > 1 && bcSfFilterConfig.custom.show_second_image) {
    itemImagesHtml += '<noscript data-rimg-noscript>' +
      '<img src="' + this.optimizeImage(images[1].src, '512x512') + '" alt="{{itemTitle}}"' +
      'data-rimg="noscript" class="productitem--image-alternate"' +
      'srcset="' + this.optimizeImage(images[1].src, '512x512') + '"' +
      '>' +
      '</noscript>';
    itemImagesHtml += '<img src="' + this.optimizeImage(images[1].src, '512x512') + '" class="productitem--image-alternate" alt="{{itemTitle}}" ' +
      'data-rimg="loaded" data-rimg-scale="1" data-rimg-template="' + this.optimizeImage(images[1].src, '{size}') + '" ' +
      'data-rimg-max="' + images[1]['width'] + 'x' + images[1]['height'] + '" data-rimg-crop ' +
      'srcset="' + this.optimizeImage(images[1].src, '512x512') + '" ' +
      'data-rimg-template-svg="data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\'512\'%20height=\'512\'></svg>"' +
      '>';
    itemImagesHtml += '<div data-rimg-canvas></div>';
  }
  if (images.length > 0) {
    itemImagesHtml += '<noscript data-rimg-noscript>' +
      '<img src="' + this.optimizeImage(images[0].src, '512x512') + '" alt="{{itemTitle}}"' +
      'data-rimg="noscript"' +
      'srcset="' + this.optimizeImage(images[0].src, '512x512') + '"' +
      '>' +
      '</noscript>';
    itemImagesHtml += '<img src="' + this.optimizeImage(images[0].src, '512x512') + '" alt="{{itemTitle}}" ' +
      'data-rimg="loaded" data-rimg-scale="1" data-rimg-template="' + this.optimizeImage(images[0].src, '{size}') + '" ' +
      'data-rimg-max="' + images[0]['width'] + 'x' + images[0]['height'] + '" data-rimg-crop ' +
      'srcset="' + this.optimizeImage(images[0].src, '512x512') + '" ' +
      'data-rimg-template-svg="data:image/svg+xml;utf8,<svg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\'512\'%20height=\'512\'></svg>"' +
      '>';
    itemImagesHtml += '<div data-rimg-canvas></div>';
  }
  itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

  // Add Label
  var itemLabelsHtml = '';
  if (soldOut) {
    itemLabelsHtml += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out +'</span>';
  } else {
    if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
      var savePrice = data.compare_at_price_min - data.price_min;
      var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_max);
      var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
      var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
      itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
      switch (bcSfFilterConfig.custom.product_sales_badge_style) {
        case 'percentile': itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml); break;
        case 'money': itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice)); break;
        default: itemLabelsHtml += bcSfFilterConfig.label.sale; break;
      }
      itemLabelsHtml += '</span>';
    }
  }
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

  var comparePrice = data.compare_at_price_max || 0;
  itemHtml = itemHtml.replace(/{{itemCompareAtPriceMax}}/g, comparePrice);
  itemHtml = itemHtml.replace(/{{itemPriceMin}}/g, data.price_min);

  var itemCollections = data.collections.map(function(collection){
    return collection.handle;
  });
  itemHtml = itemHtml.replace(/{{itemCollections}}/g, itemCollections.join());

  // Add Price
  var priceHtml = '<span class="limoniapps-discountninja-productprice">';
  var classVaries = priceVaries ? 'price--varies' : '';
  var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
  priceHtml += '<div class="productitem--price ghh' + classVaries + '">';
  priceHtml += '<div class="price--compare-at ' + visibleClass + '" data-price-compare-at style="font-size:0.8rem;">';
  var comparePrice = '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>';
  if (priceVaries && onSale){
    priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, comparePrice);
  } else {
    if (onSale) {
      priceHtml += comparePrice;
    } else {
      if (bcSfFilterConfig.custom.emphasize_price) {
        priceHtml += '<span class="price--spacer"></span>';
      } else {
        priceHtml += '<span class="money"></span>';
      }
    }
  }
  priceHtml += '</div>';
  priceHtml += '<div class="price--main" data-price>';
  var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
  if (priceVaries) {
    priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, price);
  } else {
    priceHtml += price;
  }
  priceHtml += '</div>';
  priceHtml += '</div></span>';

  // Add quickBtn
  var quickBtnHtml = '';
  var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
  var show_modal = bcSfFilterConfig.custom.show_modal;
  if (bcSfFilterConfig.custom.enable_quick_look == true || bcSfFilterConfig.custom.enable_quick_buy == true) {
    var quick_look_text = bcSfFilterConfig.label.quick_look_text;
    var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
    var quick_look_classes = 'productitem--action-trigger button-secondary';
    var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
    if (has_variants) {
      quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
      show_modal = true;
    }
    if (!data.available) {
      quick_buy_text = bcSfFilterConfig.label.sold_out;
      quick_buy_classes = quick_buy_classes + ' disabled';
    }
    quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
    quickBtnHtml += '<div class="productitem--listview-price">' +
      '{{emphasizePrice}}' +
      '</div>' +
      '<div class="productitem--listview-badge"></div>';
    if (bcSfFilterConfig.custom.enable_quick_look) {
      quickBtnHtml += '<div class="productitem--action">' +
        '<button class="'+ quick_look_classes +'" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' + quick_look_text +
        '</button>' +
        '</div>';
    }
    if (bcSfFilterConfig.custom.enable_quick_buy) {
      if (!has_variants) {
        var temp = ' data-quick-buy ';
      } else {
        var temp = ' data-quickshop-slim ';
      }
      quickBtnHtml += '<div class="productitem--action">' +
        '<button class="' + quick_buy_classes + '" tabindex="1" type="button" aria-label="' + quick_buy_text + '"' +
        temp + 'data-variant-id="' + data.variants[0].id + '"';
      if (!data.available) {
        quickBtnHtml += ' disabled';
      }
      quickBtnHtml += '>';
      quickBtnHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
      quickBtnHtml += '<span class="atc-button--icon">';
      quickBtnHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path> </g> </svg>';
      quickBtnHtml += '</span>';
      quickBtnHtml += '</button>';
      quickBtnHtml += '</div>';
    }

    quickBtnHtml += '</div>';
  }
  itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);

  // Add emphasize price
  var emphasizePriceHtml = '';
  var noEmphasizePriceHtml = '';
  if (bcSfFilterConfig.custom.emphasize_price) {
    emphasizePriceHtml += priceHtml;
  } else {
    noEmphasizePriceHtml += priceHtml;
  }
  itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
  itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

  // Add vendor
  var itemVendorHtml = '';
  if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '') {
    itemVendorHtml += '<h3 class="productitem--vendor">' + data.vendor + '</h3>';
  }
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add review rating
  var itemReviewsHtml = '';
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    itemReviewsHtml +=  '<div class="productitem--ratings">' +
      '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
      '<span class="spr-badge">' +
      '<span class="spr-starrating spr-badge-starrating">' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '</span>' +
      '</span>' +
      '</span>' +
      '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

  // Add description
  var itemDescriptionHtml = '';
  if (data.description && data.description.length > 0) {
    itemDescriptionHtml +=  '<div class="productitem--description">' +
      '<p>' + bcsffilter.truncateByChar(data.description, 150) + '</p>' +
      '</div>';
    if (data.description.length > 150) {
      itemDescriptionHtml += '<a href="{{itemUrl}}" class="productitem--link">' + bcSfFilterConfig.label.view_details + '</a>';
    }
  }
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }

  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;

    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);

    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }

    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

    jQ(this.selector.pagination).html(paginationHtml);
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');

    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        if (arr[k] == this.queryParams.limit) {
          showLimitItemsHtml += '<li><a class="utils-showby-item active" href="' + arr[k] +'">' + arr[k] + '</a></li>';
        } else {
          showLimitItemsHtml += '<li><a class="utils-showby-item" href="' + arr[k] +'">' + arr[k] + '</a></li>';
        }
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
    }
  }
};

BCSfFilter.prototype.buildShowLimitEvent = function() {
  var _this = this;
  jQ(this.selector.topShowLimit + ' li a').click(function(e) {
    onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).attr('href'));
  })
};

/************************** END BUILD TOOLBAR **************************/

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
    var colInfo = colData.collection;
    var delimiter = '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path></svg></span>';
    var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> ';
    breadcrumbHtml += delimiter;
    breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
    jQ('.breadcrumbs-container').html(breadcrumbHtml);
  }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span class="utils-viewtoggle-label">' + bcSfFilterConfig.label.view_as_title + ' </span>';
  itemHtml += '<button class="active bc-sf-filter-display-grid" data-display-type="' + this.buildToolbarLink('display', 'list', 'grid') + '">';
  itemHtml += '<svg class="icon-grid " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h4v4H5V5zm6 0h4v4h-4V5zm-6 6h4v4H5v-4zm6 0h4v4h-4v-4z"></path>    </svg>';
  itemHtml == '</button>';
  itemHtml += '<button class="bc-sf-filter-display-list" data-display-type= "' + this.buildToolbarLink('display', 'grid', 'list') + '">';
  itemHtml += '<svg class="icon-list " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h10v2H5V5zm0 4h10v2H5V9zm0 4h10v2H5v-2z"></path>    </svg>';
  itemHtml == '</button>';

  jQ(this.selector.topDisplayType).html(itemHtml);

  // Active current display type
  jQ(this.selector.topDisplayType).find('button').removeClass('active');
  if (this.queryParams.display == 'list') {
    jQ(this.selector.topDisplayType).find('button.bc-sf-filter-display-list').addClass('active');
  } else if (this.queryParams.display == 'grid') {
    jQ(this.selector.topDisplayType).find('button.bc-sf-filter-display-grid').addClass('active');
  }
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  jQ(this.selector.topDisplayType + ' button').unbind('click');
  jQ(this.selector.topDisplayType + ' button').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children('button').removeClass('active');
    jQ(this).addClass('active');
    var newUrl = jQ(this).attr('data-display-type');
    if (newUrl.indexOf('list') != -1) {
      jQ('.productgrid--outer').addClass('productgrid-listview');
    } else {
      jQ('.productgrid--outer').removeClass('productgrid-listview');
    }
    _this.onChangeData(newUrl, 'display');
  })
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // var sections = new Sections();
  // sections.register('static-collection', function (section) {
  //     return new StaticCollection(section);
  // });

  // Integrate Product Reviews
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    !function(){var e=function(e){var t={exports:{}};return e.call(t.exports,t,t.exports),t.exports};e(function(){"use strict";window.innerShiv=function(){function e(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var t,r,a=document,i="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(n,s){if(!t&&(t=a.createElement("div"),t.innerHTML="<nav></nav>",r=1!==t.childNodes.length)){for(var o=a.createDocumentFragment(),d=i.length;d--;)o.createElement(i[d]);o.appendChild(t)}if(n=n.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,e),t.innerHTML=(o=n.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+n+"</table>":n,o=o?t.getElementsByTagName(o[1])[0].parentNode:t,!1===s)return o.childNodes;for(var d=a.createDocumentFragment(),u=o.childNodes.length;u--;)d.appendChild(o.firstChild);return d}}()});(function(){window.SPR=function(){function e(){}return e.shop=Shopify.shop,e.host="//productreviews.shopifycdn.com",e.version="v4",e.api_url=e.host+"/proxy/"+e.version,e.badgeEls=[],e.reviewEls=[],e.elSettings={},e.$=void 0,e.extraAjaxParams={shop:e.shop},e.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},e.loadStylesheet=function(){var e,t;return t=document.createElement("link"),t.setAttribute("rel","stylesheet"),t.setAttribute("type","text/css"),t.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-5a2d2fd286dca8042a3a5a76bc9032c64c52a2792a734307c76740d012641514.css"),t.setAttribute("media","screen"),e=document.getElementsByTagName("head")[0],e.appendChild(t)},e.initRatingHandler=function(){return e.$(document).on("mouseover mouseout","form a.spr-icon-star",function(t){var r,a,i;return r=t.currentTarget,i=e.$(r).attr("data-value"),a=e.$(r).parent(),"mouseover"===t.type?(a.find("a.spr-icon:lt("+i+")").addClass("spr-icon-star-hover"),a.find("a.spr-icon:gt("+(i-1)+")").removeClass("spr-icon-star-hover")):a.find("a.spr-icon").removeClass("spr-icon-star-hover")})},e.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(e){return function(t,r){var a;return a=e.$(r).attr("data-id"),e.elSettings[a]={},e.elSettings[a].reviews_el="#"+(e.$(r).attr("data-reviews-prefix")?e.$(r).attr("data-reviews-prefix"):"reviews_"),e.elSettings[a].form_el="#"+(e.$(r).attr("data-form-prefix")?e.$(r).attr("data-form-prefix"):"form_")}}(this))},e.loadProducts=function(){return this.$.each(this.reviewEls,function(e){return function(t,r){var a,i;if(a=e.$(r).attr("data-id"),"false"!==e.$(r).attr("data-autoload"))return i=e.$.extend({product_id:a,version:e.version},e.extraAjaxParams),e.$.get(e.api_url+"/reviews/product",i,e.productCallback,"jsonp")}}(this))},e.loadBadges=function(){var e,t,r,a,i;if(r=this.$.map(this.badgeEls,function(e){return function(t){return e.$(t).attr("data-id")}}(this)),r.length>0){for(t=7,i=[];(e=r.splice(0,t)).length>0;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},e.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},e.submitForm=function(e){var t;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=this.$.param(t),t=t.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:function(e){return function(){return e.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(e){return function(){return e.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},e.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},e.toggleReviews=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-reviews").toggle()},e.toggleForm=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-form").toggle()},e.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},e.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},e.badgesCallback=function(t){var r;return r=t.badges,e.$.map(e.badgeEls,function(t){var a;if(a=e.$(t).attr("data-id"),r[a]!==undefined)return e.$(t).replaceWith(r[a]),e.triggerEvent("spr:badge:loaded",{id:a})})},e.productCallback=function(t){var r;return r=t.remote_id.toString(),e.renderProduct(r,t.product),e.renderForm(r,t.form),e.renderReviews(r,t.reviews)},e.renderProduct=function(e,t){return this.$.map(this.reviewEls,function(r){return function(a){if(e===r.$(a).attr("data-id"))return r.$(a).html(innerShiv(t,!1)),r.triggerEvent("spr:product:loaded",{id:e})}}(this))},e.renderForm=function(e,t){var r;return r=this.$(this.elSettings[e].form_el+e),r.html(t),this.triggerEvent("spr:form:loaded",{id:e})},e.renderReviews=function(t,r){var a;return a=e.$(e.elSettings[t].reviews_el+t),a.html(r),e.triggerEvent("spr:reviews:loaded",{id:t})},e.formCallback=function(t){var r,a,i,n;return n=t.status,i=t.remote_id,a=t.form,r=e.$(e.elSettings[i].form_el+i),r.html(a),"failure"===n&&e.initStarRating(r),"success"===n&&e.$("#shopify-product-reviews[data-id='"+i+"'] .spr-summary-actions-newreview").hide(),e.triggerEvent("spr:form:"+n,{id:i})},e.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},e.paginateCallback=function(t){var r,a;return a=t.remote_id.toString(),r=t.reviews,e.renderReviews(a,r)},e.reportCallback=function(t){var r;return r="#report_"+t.id,e.$(r).replaceWith("<span class='spr-review-reportreview'>"+e.$(r).attr("data-msg")+"</span>")},e.loadjQuery=function(t){return e.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return e.$=jQuery.noConflict(!0),t()})},e.loadScript=function(e,t){var r;return r=document.createElement("script"),r.type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},e.loadjQueryExtentions=function(e){return e.fn.serializeObject=function(){var t,r;return t={},r=this.serializeArray(),e.each(r,function(){return t[this.name]?(t[this.name].push||(t[this.name]=[t[this.name]]),t[this.name].push(this.value||"")):t[this.name]=this.value||""}),t}},e.triggerEvent=function(e,t){return this.$(document).trigger(e,t)},e}(),function(){SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}).call(this)}("undefined"!=typeof global?global:"undefined"!=typeof window&&window);
  }
  
  var totalProduct = data.length - 1;
  this.buildExtrasProductListByAjax(data, 'boost-pfs-flair', function(results) {
    results.forEach(function(result, index) {
      // the product item selector will be based on the theme style
      jQ('.boost-pfs-flair-'+ result.id).empty().html(result.flair);
      
      jQ('#' + result.handle).after(result.quickview);
      jQ('#' + result.handle).find('.productitem--action').css('display', 'block');
      if (index == totalProduct) {
        var sections = new bcSections();
        sections.register('static-collection', function (section) {
          return new bcStaticCollection(section);
        });
      }
    });
  });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  if (this.queryParams.display == 'list') {
    jQ('.productgrid--outer').addClass('productgrid-listview');
  } else {
    jQ('.productgrid--outer').removeClass('productgrid-listview');
  }
  if(typeof discountNinja != 'undefined' ){
    discountNinja.DynamicPricing.UpdatePrice();
  }
  //jQ('#bc-sf-filter-products').css('display', 'flex');
};

BCSfFilter.prototype.catchError = function(result, eventType) {
  if (result.total_product <= 0) {
    if (!this.checkExistFilterOptionParam()) {
      var errorContent = '';
      if (this.isSearchPage()) {
        errorContent = this.getSettingValue('label.error.noSearchResult');
      } else {
        // Only print the message "No products found in this collection" if the number of products in a collection is 0
        if (result.total_product == 0 && this.productAvailable) {
          errorContent = this.getSettingValue('label.error.noProducts');
        }
      }
    } else {
      errorContent = this.getSettingValue('label.error.noFilterResult');
    }
    if (errorContent != '') {
      template = this.getTemplate('noResult').replace(/{{content}}/g, errorContent);
      jQ(this.getSelector('products')).html(template);
      jQ(this.getSelector('pagination')).empty();
      jQ(this.getSelector('topShowLimit')).empty();
      jQ(this.getSelector('topSorting')).empty('');
    }
    return;
  }
};

// Fix: Recently Viewed
// + empire.js
//
// + Find: RecentlyViewed và recentlyViewed = JSON.parse
//
// + Replace by recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
// if(typeof bcsffilter === 'undefined' || (typeof bcsffilter !== 'undefined' && bcsffilter.queryParams.event_type == 'init' && bcsffilter.hasFilterOptionParam === false)){


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; } return data };

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

BCSfFilter.prototype.buildProductItemUrl = function(data, hasCollection) {
    // Get url information
    var params = window.location.search.substring(1);
    var pathname = window.location.pathname;

    // Get product handle
    var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;

    var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : true;
    if (hasCollection) {
        // Homepage or Search page
        if (pathname == '/' || this.isSearchPage() || this.isVendorPage() || this.isTypePage()) {
            return '/collections/all/products/' + handle;
        }
        // Tag Page
        else if (this.isTagPage()) {
            var elements = pathname.split('/');
            if (elements.length >= 4) return '/collections/' + elements[2] + '/products/' + handle;
            return '/collections/all/products/' + handle;
        } else {
            // Google cache URL
            // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
            if (params.indexOf('cache:') > -1) {
                var collectionHandle = 'all';
                var temp = params.split('&')[0].split('?')[0].split('collections/');
                if (temp.length > 1) {
                    if (temp[1].indexOf('/') > -1) collectionHandle = temp[1].split('/')[0];
                    else collectionHandle = temp[1];
                }
                collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
                return '/collections/' + collectionHandle + '/products/' + handle;
            }

            var elements = pathname.split('/');
            if (typeof elements[2] !== 'undefined') return '/collections/' + elements[2] + '/products/' + handle;
            return window.location.pathname + '/products/' + handle;
        }
    }
    return '/products/' + handle;
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
